var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ridership-interval-toggle d-flex align-items-center gap-2"},[_c('span',{staticClass:"rd-interval-label"},[_vm._v(_vm._s(_vm.$t('flexigo.ridership.interval')))]),_c('toggle-button-group',{attrs:{"options":_vm.intervalOptions},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }